// import { createPercentFormatter } from '../../../utils/formatter/formatter'

// const pctFmt = createPercentFormatter({ minimumFractionDigits: 0, maximumFractionDigits: 0 });

// const aggregateSumByMonth = (data, field) => {
//   const map = new Map();
//   data.forEach(d => {
//     if (d?.month == null) return;
//     const value = d[field] != null ? parseFloat(d[field]) : null;
//     if (value == null || isNaN(value)) return;
//     const key = String(d.month).padStart(2, '0');
//     map.set(key, (map.get(key) ?? 0) + value);
//   });
//   return map;
// };

// export const buildDeltaPlanoRow = ({ monthKeys, planoAgg, realizadoAgg, field }) => {
//   const rawValues = monthKeys.map((_, i) => {
//     const plano = planoAgg[i]?.[`_${field}`];
//     const real = realizadoAgg[i]?.[`_${field}`];
//     return (plano != null && real != null && plano !== 0) ? (real - plano) / plano : null;
//   });

//   const values = rawValues.map(v => v != null ? pctFmt.format(v) : null);

//   const sumRange = (agg, from, to) => {
//     const vals = agg.slice(from, to).map(a => a?.[`_${field}`]).filter(v => v != null);
//     return vals.length ? vals.reduce((s, v) => s + v, 0) : null;
//   };

//   const semDelta = (planoSum, realSum) =>
//     (planoSum != null && realSum != null && planoSum !== 0) ? (realSum - planoSum) / planoSum : null;

//   const plano1 = sumRange(planoAgg, 0, 6), real1 = sumRange(realizadoAgg, 0, 6);
//   const plano2 = sumRange(planoAgg, 6, 12), real2 = sumRange(realizadoAgg, 6, 12);
//   const planoT = (plano1 ?? 0) + (plano2 ?? 0);
//   const realT  = (real1 ?? 0) + (real2 ?? 0);

//   const s1 = semDelta(plano1, real1);
//   const s2 = semDelta(plano2, real2);
//   const sT = semDelta(planoT, realT);

//   return {
//     values,
//     rawValues,
//     semValues: [s1, s2, sT].map(v => v != null ? pctFmt.format(v) : null),
//     semRawValues: [s1, s2, sT],
//     colorFn: (v) => v == null ? "#bbb" : v >= 0 ? "#1e8a42" : "#e05252",
//   };
// };

// export const buildDeltaAnoAnteriorRow = ({ monthKeys, realizadoAgg, realizadoLastYearData, field }) => {
//   const lastYearByMonth = aggregateSumByMonth(realizadoLastYearData, field);

//   const rawValues = monthKeys.map((key, i) => {
//     const monthNum = key.split('-')[1];
//     const real = realizadoAgg[i]?.[`_${field}`];
//     const lastYear = lastYearByMonth.get(monthNum) ?? null;
//     return (real != null && lastYear != null && lastYear !== 0) ? (real - lastYear) / lastYear : null;
//   });

//   const values = rawValues.map(v => v != null ? pctFmt.format(v) : null);

//   const sumRealRange = (from, to) => {
//     const vals = realizadoAgg.slice(from, to).map(a => a?.[`_${field}`]).filter(v => v != null);
//     return vals.length ? vals.reduce((s, v) => s + v, 0) : null;
//   };
//   const sumLastYearRange = (from, to) => {
//     const vals = monthKeys.slice(from, to).map(k => lastYearByMonth.get(k.split('-')[1])).filter(v => v != null);
//     return vals.length ? vals.reduce((s, v) => s + v, 0) : null;
//   };

//   const semDelta = (lastSum, realSum) =>
//     (lastSum != null && realSum != null && lastSum !== 0) ? (realSum - lastSum) / lastSum : null;

//   const real1 = sumRealRange(0, 6), last1 = sumLastYearRange(0, 6);
//   const real2 = sumRealRange(6, 12), last2 = sumLastYearRange(6, 12);
//   const realT = (real1 ?? 0) + (real2 ?? 0);
//   const lastT = (last1 ?? 0) + (last2 ?? 0);

//   return {
//     values,
//     rawValues,
//     semValues: [semDelta(last1, real1), semDelta(last2, real2), semDelta(lastT, realT)].map(v => v != null ? pctFmt.format(v) : null),
//     semRawValues: [semDelta(last1, real1), semDelta(last2, real2), semDelta(lastT, realT)],
//     colorFn: (v) => v == null ? "#bbb" : v >= 0 ? "#1e8a42" : "#e05252",
//   };
// };

import { createPercentFormatter } from '../../../utils/formatter/formatter'

const pctFmt = createPercentFormatter({ minimumFractionDigits: 0, maximumFractionDigits: 0 });

const aggregateSumByMonth = (data, field) => {
  const map = new Map();
  data.forEach(d => {
    if (d?.month == null) return;
    const value = d[field] != null ? parseFloat(d[field]) : null;
    if (value == null || isNaN(value)) return;
    const key = String(d.month).padStart(2, '0');
    map.set(key, (map.get(key) ?? 0) + value);
  });
  return map;
};

export const buildDeltaPlanoRow = ({ monthKeys, planoAgg, realizadoAgg, field, summaryPeriods }) => {
  const rawValues = monthKeys.map((_, i) => {
    const plano = planoAgg[i]?.[`_${field}`];
    const real = realizadoAgg[i]?.[`_${field}`];
    return (plano != null && real != null && plano !== 0) ? (real - plano) / plano : null;
  });

  const values = rawValues.map(v => v != null ? pctFmt.format(v) : null);

  const sumRange = (agg, monthIndexes) => {
    const vals = monthIndexes.map(i => agg[i]?.[`_${field}`]).filter(v => v != null);
    return vals.length ? vals.reduce((s, v) => s + v, 0) : null;
  };

  const semDelta = (planoSum, realSum) =>
    (planoSum != null && realSum != null && planoSum !== 0) ? (realSum - planoSum) / planoSum : null;

  const semRawValues = summaryPeriods.map(p =>
    semDelta(sumRange(planoAgg, p.monthIndexes), sumRange(realizadoAgg, p.monthIndexes))
  );

  return {
    values,
    rawValues,
    semValues: semRawValues.map(v => v != null ? pctFmt.format(v) : null),
    semRawValues,
    colorFn: (v) => v == null ? "#bbb" : v >= 0 ? "#1e8a42" : "#e05252",
  };
};

export const buildDeltaAnoAnteriorRow = ({ monthKeys, realizadoAgg, realizadoLastYearData, field, summaryPeriods }) => {
  const lastYearByMonth = aggregateSumByMonth(realizadoLastYearData, field);

  const rawValues = monthKeys.map((key, i) => {
    const monthNum = key.split('-')[1];
    const real = realizadoAgg[i]?.[`_${field}`];
    const lastYear = lastYearByMonth.get(monthNum) ?? null;
    return (real != null && lastYear != null && lastYear !== 0) ? (real - lastYear) / lastYear : null;
  });

  const values = rawValues.map(v => v != null ? pctFmt.format(v) : null);

  const sumRealRange = (monthIndexes) => {
    const vals = monthIndexes.map(i => realizadoAgg[i]?.[`_${field}`]).filter(v => v != null);
    return vals.length ? vals.reduce((s, v) => s + v, 0) : null;
  };
  const sumLastYearRange = (monthIndexes) => {
    const vals = monthIndexes.map(i => lastYearByMonth.get(monthKeys[i].split('-')[1])).filter(v => v != null);
    return vals.length ? vals.reduce((s, v) => s + v, 0) : null;
  };

  const semDelta = (lastSum, realSum) =>
    (lastSum != null && realSum != null && lastSum !== 0) ? (realSum - lastSum) / lastSum : null;

  const semRawValues = summaryPeriods.map(p =>
    semDelta(sumLastYearRange(p.monthIndexes), sumRealRange(p.monthIndexes))
  );

  return {
    values,
    rawValues,
    semValues: semRawValues.map(v => v != null ? pctFmt.format(v) : null),
    semRawValues,
    colorFn: (v) => v == null ? "#bbb" : v >= 0 ? "#1e8a42" : "#e05252",
  };
};